// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1GDl1","detailsBorder":"styles_detailsBorder__1l3uL"};